import name from './name';
import { createActionType } from '../../core';
const NAME = name.toUpperCase();
export const LOGIN = createActionType(`${NAME}/LOGIN`);
export const LOGIN_WITH_PROVIDER = createActionType(`${NAME}/LOGIN_WITH_PROVIDER`);
export const CREATE_ACCOUNT = createActionType(`${NAME}/CREATE_ACCOUNT`);
